import {
    aqua,
    black,
    blue,
    error,
    gold,
    green,
    info,
    lightGreen,
    lilac,
    orange,
    purple,
    red,
    success,
    warning,
    white,
    violet,
    yellow,
    lavender,
} from "./baseColors";
import { gradientProxy } from "./gradientProxy";
import { BasePalette } from "./palette.types";

export const basePalette: BasePalette = {
    primary: violet,
    white,
    black,
    blue,
    green: {
        200: lightGreen,
        600: green,
    },
    gold,
    red,
    aqua,
    purple,
    lilac,
    orange,
    gradient: gradientProxy,
    lavender,
    status: {
        info,
        success,
        warning,
        error,
    },
    yellow,
    secondary: yellow,
};
